module.exports = __webpack_public_path__ + "img/spartan-contact.dd0dd987.jpg";